/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  // import config from "../config/issueCredential.config.json";
  // import notification from "../config/notifications.config.json";
  import axios from "axios";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { SHOWCASE_PORTFOLIO } from "../graphql";
  import { VApplication } from "../../../application";
  import {useCollection} from "../provider";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface IShowcasePortfolioMethods extends IPluginMethodMap {
    getShowcasePortfolio(args: any): Promise<any>;
  }
  
  export interface ShowcasePortfolioProps {
    portfolioId:string;
  }
  
  export class ShowcasePortfolioService implements IAgentPlugin {
    readonly methods: IShowcasePortfolioMethods;
    constructor() {
      this.methods = {
        getShowcasePortfolio: this.getShowcasePortfolio.bind(this),
      };
    }
  
    async getShowcasePortfolio(args: ShowcasePortfolioProps) {
      console.log(`args in issue credential`, args);
      const {portfolioTempId} = useCollection();
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");

      try {
        // console.log('args in update service', args);
        if (client) {
          const res = await client.mutate({
            mutation: SHOWCASE_PORTFOLIO,
            variables: {
              portfolioId:portfolioTempId,
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data?.showcasePortfolio) {
            console.log(`Update status`, res);
            return res?.data?.showcasePortfolio;
          }
        }
      } catch (err: any) {
        // console.log("error in issue credential", err?.message);
        throw err;
      }
    }
  }
  